<div
  class="w-[264px] h-[25px] max-sm:w-[128px] max-sm:h-[19px] rounded-6 mb-4 animate-pulse bg-[#DDDEE0]"
></div>
<div
  class="w-full h-238 mb-12 rounded-10 max-sm:rounded-5 max-sm:h-81 animate-pulse bg-[#DDDEE0]"
></div>
